import moment from "moment";
import React, { Component } from "react";
import BatchJobExtractionServices from "../../services/axiosServices/apiServices/BatchJobExtractionServices";
import SwalServices from "../../services/swalServices/SwalServices";
import { saveAs } from "file-saver";
import PageLoader from "../../components/common/pageLoader/PageLoader";
import ButtonLoader from "../../components/common/buttonLoader/ButtonLoader";

export default class ARAgingReport extends Component {
    constructor(props) {
        super(props);
        this.batchJobExtractionServices = new BatchJobExtractionServices();
        this.swalServices = new SwalServices();
        this.state = {
            pagination: {
                pageNo: 1,
                pageSize: 10,
                orderByColumn: "CreatedAt",
                orderFlag: 0,
                searchText: "",
            },
            isLoading: false,
            currentDate: new Date(),
            ARAgingReportList: [],
            totalCount: 0,

        };
    }

    componentDidMount = () => {
        this.getAllARAgingReportList();

    }

    getAllARAgingReportList = () => {
        this.setState({ isLoading: true });
        let pagination = { ...this.state.pagination };
        this.batchJobExtractionServices.getAllARAgingReportList(pagination).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                let details = response.responseItem.responseContent.itemList;
                this.setState({
                    ARAgingReportList: details,
                    totalCount: response.responseItem.responseContent.totalCount,
                })
            }
            else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        }).catch(() => {
            this.setState({ isLoading: false });
            this.swalServices.Error("Something went wrong. Please try again.");
        });
    }


    generateARAgingReport = () => {
        if (this.state.isLoading) return;
        if (this.state.currentDate) {
            this.setState({ isLoading: true });
            let request = {
                currentDate: this.state.currentDate
            };
            this.batchJobExtractionServices.generateARAgingReport(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem != null) {
                    this.swalServices.Success("AR Aging record generated successfully.");
                    this.getAllARAgingReportList();
                }
                else if (response.statusCode === 409) {
                    this.swalServices.Error(response.message);
                }
                else {
                    this.swalServices.Error(response.message);
                }
                this.setState({ isLoading: false });
            }).catch(() => {
                this.setState({ isLoading: false });
                this.swalServices.Error("Something went wrong. Please try again.");
            });
        }
        else {
            this.swalServices.Alert('Please select date');
        }
    }



    downloadARAgingSheetByARAgingReportId = (arAgingReportId) => {
        this.setState({ isLoading: true });
        let request = [];
        request.push(arAgingReportId);
        this.batchJobExtractionServices.downloadARAgingSheetByARAgingReportId(request).then((response) => {
            if (response.status === 200 && response.data != null) {
                // var filename = `${detail}${formattedDate}`;
                let blob = new Blob([response.data])
                saveAs(blob, `ARAgingReport` + ".xlsx");
            }
            else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        }).catch(() => {
            this.setState({ isLoading: false });
            this.swalServices.Error("Something went wrong. Please try again.");
        });
    }

    handleChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if (name === 'currentDate') {
            this.setState({ currentDate: value })
        }

    }

    render() {
        return (
            <div className="main-body-section finance-body-sec">
                {/* Business Transaction Batch Job Start */}

                <div className="bg-white">
                    {/* <div className="heading-part pl-7 py-4 border-b">
                        <div className="flex items-center justify-between">
                            <h4 className="small-title font-bold theme-color">
                                Business Transaction Batch Job
                            </h4>
                        </div>
                    </div> */}

                    <div className="grid grid-cols-12 gap-6 w-full items-center px-8 py-10">
                        <div className=" 2xl:col-span-3 lg:col-span-3 col-span-12 w-full hidden">
                            <h2 className="text-xl theme-color mb-1">
                                Invoice Number
                                <span className="text-[#C00000]">*</span>
                            </h2>
                            <input
                                id="default"
                                name="filterbyInvoiceNumber"
                                className="form-input rounded-none w-full shadow-red py-3 text-lg"
                                type="text"
                            // onChange={(event) => this.handleChange(event)}
                            // value={this.state.pagination.filterbyInvoiceNumber}
                            />
                        </div>
                        <div className="col-span-3">
                            <label
                                className="block text-xl font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                                htmlFor="default"
                            >
                                Date<span className="text-[#C00000]">*</span>
                            </label>
                            <div className="disabled-input">
                                <input
                                    id="currentDate"
                                    name="currentDate"
                                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                                    type="date"
                                    value={moment(this.state.currentDate).format("yyyy-MM-DD")}
                                    onChange={(event) => this.handleChange(event)}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-span-4">
                            {this.state.isLoading ? <ButtonLoader className="mt-8" /> :
                            <button className="btn btn-red text-xl border text-white mt-8" onClick={() => this.generateARAgingReport()}>
                                Generate AR Aging Report
                            </button>}
                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-6 w-full items-center justify-center px-8 py-10">
                        <div className="2xl:col-span-12 lg:col-span-12 col-span-12 w-full">
                            {this.state.isLoading ? <PageLoader /> :
                                <table className="w-full mx-auto my-5 fixed_header batch-job-extraction-table border">
                                    <thead>
                                        <tr className="text-base font-bold flex">
                                            <th className="px-2 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white w-[40%]">
                                                <div className="font-bold tble-th-txt text-left">
                                                    Generate Date
                                                </div>
                                            </th>
                                            {/* <th className="px-2 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white w-[30%]">
                                                <div className="font-bold tble-th-txt text-left">
                                                    Report ID
                                                </div>
                                            </th> */}
                                            <th className="px-2 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white w-[40%]">
                                                <div className="font-bold tble-th-txt text-left">
                                                    Number of Records
                                                </div>
                                            </th>

                                            <th className="px-2 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white w-[20%]">
                                                <div className="font-bold tble-th-txt text-center">Action</div>
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody className="scrollit text-sm custom-tbody">
                                        {this.state.ARAgingReportList.map((e, key) => {
                                            return (
                                                <tr className="custom-tbl-td flex items-center" key={key}>
                                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[40%] ">
                                                        {moment(e.generationDate).format("DD MMM YYYY")}
                                                    </td>
                                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[40%]">
                                                        {e.numberOfRecords}
                                                    </td>

                                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[20%]">
                                                        <button
                                                            className="action-btn mx-auto flex items-center"
                                                            aria-controls="add-edit-modal"
                                                            onClick={() => {
                                                                this.downloadARAgingSheetByARAgingReportId(e.arAgingReportId);
                                                            }}
                                                        >
                                                            <p className="ml-2 tool-tip-txt underline text-[#81a3b8]">
                                                                Download
                                                            </p>
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}

                                    </tbody>
                                </table>
                            }
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}
